/**
 * Moodle E-Learning Courses Type Definitions
 *
 * These types define the structure of Moodle e-learning courses
 * as returned by the backend API endpoint:
 * - GET /api/user/moodle-courses
 */

/**
 * Inviter information for courses enrolled via invitation
 */
export interface MoodleCourseInviter {
  first_name: string;
  last_name: string;
  email: string;
  order_number: string;
}

/**
 * Enrollment source type
 */
export type EnrollmentSource = 'self' | 'invited';

/**
 * Single Moodle course
 */
export interface MoodleCourse {
  id: number;
  fullname: string;
  shortname: string;
  category: number;
  progress: number; // 0-100 percentage
  timecreated: number | null; // Unix timestamp or null
  enrollment_timestart: number; // Unix timestamp when enrollment started
  enrollment_timeend: number; // Unix timestamp when enrollment ends
  remaining_days: number;
  url: string;
  image: string; // Course image URL with token
  enrollment_source: EnrollmentSource;
  inviter?: MoodleCourseInviter; // Only present when enrollment_source is 'invited'
}

/**
 * API response for Moodle courses
 */
export type MoodleCoursesApiResponse = MoodleCourse[];

/**
 * Progress status for display purposes
 */
export type CourseProgressStatus = 'not_started' | 'in_progress' | 'completed';

/**
 * Helper to determine progress status from course
 */
export const getCourseProgressStatus = (course: MoodleCourse): CourseProgressStatus => {
  if (course.progress === 0) return 'not_started';
  if (course.progress === 100) return 'completed';
  return 'in_progress';
};
